/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as GloplaUserLayoutImport } from './routes/_gloplaUserLayout'
import { Route as EmbaUserLayoutImport } from './routes/_embaUserLayout'
import { Route as SigninIndexRouteImport } from './routes/signin/index.route'
import { Route as ErrorTestIndexRouteImport } from './routes/error-test/index.route'
import { Route as EmbaUserLayoutLearnerLayoutImport } from './routes/_embaUserLayout/_learnerLayout'
import { Route as GloplaUserLayoutTermsOfServiceIndexRouteImport } from './routes/_gloplaUserLayout/terms-of-service/index.route'
import { Route as GloplaUserLayoutSelectUserEnrollmentIndexRouteImport } from './routes/_gloplaUserLayout/select-user-enrollment/index.route'
import { Route as EmbaUserLayoutLearnerLayoutIndexRouteImport } from './routes/_embaUserLayout/_learnerLayout/index.route'
import { Route as EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport } from './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout'
import { Route as EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteImport } from './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/index.route'
import { Route as EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteImport } from './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/index.route'
import { Route as EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteImport } from './routes/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/index.route'
import { Route as EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteImport } from './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/index.route'
import { Route as EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteImport } from './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/index.route'
import { Route as EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteImport } from './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/index.route'

// Create Virtual Routes

const EmbaUserLayoutUserAttendancesUserAttendanceSlugImport = createFileRoute(
  '/_embaUserLayout/user-attendances/$userAttendanceSlug',
)()
const EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/',
  )()
const EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/',
  )()
const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyImport =
  createFileRoute(
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/',
  )()

// Create/Update Routes

const GloplaUserLayoutRoute = GloplaUserLayoutImport.update({
  id: '/_gloplaUserLayout',
  getParentRoute: () => rootRoute,
} as any)

const EmbaUserLayoutRoute = EmbaUserLayoutImport.update({
  id: '/_embaUserLayout',
  getParentRoute: () => rootRoute,
} as any)

const SigninIndexRouteRoute = SigninIndexRouteImport.update({
  id: '/signin/',
  path: '/signin/',
  getParentRoute: () => rootRoute,
} as any)

const ErrorTestIndexRouteRoute = ErrorTestIndexRouteImport.update({
  id: '/error-test/',
  path: '/error-test/',
  getParentRoute: () => rootRoute,
} as any)

const EmbaUserLayoutLearnerLayoutRoute =
  EmbaUserLayoutLearnerLayoutImport.update({
    id: '/_learnerLayout',
    getParentRoute: () => EmbaUserLayoutRoute,
  } as any)

const EmbaUserLayoutUserAttendancesUserAttendanceSlugRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugImport.update({
    id: '/user-attendances/$userAttendanceSlug',
    path: '/user-attendances/$userAttendanceSlug',
    getParentRoute: () => EmbaUserLayoutRoute,
  } as any)

const GloplaUserLayoutTermsOfServiceIndexRouteRoute =
  GloplaUserLayoutTermsOfServiceIndexRouteImport.update({
    id: '/terms-of-service/',
    path: '/terms-of-service/',
    getParentRoute: () => GloplaUserLayoutRoute,
  } as any)

const GloplaUserLayoutSelectUserEnrollmentIndexRouteRoute =
  GloplaUserLayoutSelectUserEnrollmentIndexRouteImport.update({
    id: '/select-user-enrollment/',
    path: '/select-user-enrollment/',
    getParentRoute: () => GloplaUserLayoutRoute,
  } as any)

const EmbaUserLayoutLearnerLayoutIndexRouteRoute =
  EmbaUserLayoutLearnerLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EmbaUserLayoutLearnerLayoutRoute,
  } as any)

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport.update(
    {
      id: '/_lessonSideBarLayout',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugRoute,
    } as any,
  )

const EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyRoute =
  EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyImport.update(
    {
      id: '/enrollment-course/$enrollmentCourseId/',
      path: '/enrollment-course/$enrollmentCourseId/',
      getParentRoute: () => EmbaUserLayoutLearnerLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteImport.update(
    {
      id: '/skill-check-test/',
      path: '/skill-check-test/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/',
      path: '/lessons/$lessonSlug/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteImport.update(
    {
      id: '/skill-check-test/result/',
      path: '/skill-check-test/result/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  )

const EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteRoute =
  EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteImport.update(
    {
      id: '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/',
      path: '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/',
      getParentRoute: () => EmbaUserLayoutLearnerLayoutRoute,
    } as any,
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/role-play-description/',
      path: '/lessons/$lessonSlug/role-play-description/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/reflection-self-summarizing-answers/',
      path: '/lessons/$lessonSlug/reflection-self-summarizing-answers/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/reflection-description/',
      path: '/lessons/$lessonSlug/reflection-description/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/goal-dialog-description/',
      path: '/lessons/$lessonSlug/goal-dialog-description/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/complete/',
      path: '/lessons/$lessonSlug/complete/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyRoute =
  EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyImport.update(
    {
      id: '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/',
      path: '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/',
      getParentRoute: () => EmbaUserLayoutLearnerLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteImport.update(
    {
      id: '/lessons/$lessonSlug/role-play-result/',
      path: '/lessons/$lessonSlug/role-play-result/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteImport.update(
    {
      id: '/lessons/$lessonSlug/reflection-result/',
      path: '/lessons/$lessonSlug/reflection-result/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteImport.update(
    {
      id: '/lessons/$lessonSlug/goal-dialog-result/',
      path: '/lessons/$lessonSlug/goal-dialog-result/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/role-play-session/$sessionSlug/',
      path: '/lessons/$lessonSlug/role-play-session/$sessionSlug/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/reflection-session/$sessionSlug/',
      path: '/lessons/$lessonSlug/reflection-session/$sessionSlug/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/index.route.lazy'
    ).then((d) => d.Route),
  )

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyRoute =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyImport.update(
    {
      id: '/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/',
      path: '/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/',
      getParentRoute: () =>
        EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/index.route.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_embaUserLayout': {
      id: '/_embaUserLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof EmbaUserLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_gloplaUserLayout': {
      id: '/_gloplaUserLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof GloplaUserLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_embaUserLayout/_learnerLayout': {
      id: '/_embaUserLayout/_learnerLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof EmbaUserLayoutLearnerLayoutImport
      parentRoute: typeof EmbaUserLayoutImport
    }
    '/error-test/': {
      id: '/error-test/'
      path: '/error-test'
      fullPath: '/error-test'
      preLoaderRoute: typeof ErrorTestIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/signin/': {
      id: '/signin/'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/_embaUserLayout/_learnerLayout/': {
      id: '/_embaUserLayout/_learnerLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof EmbaUserLayoutLearnerLayoutIndexRouteImport
      parentRoute: typeof EmbaUserLayoutLearnerLayoutImport
    }
    '/_gloplaUserLayout/select-user-enrollment/': {
      id: '/_gloplaUserLayout/select-user-enrollment/'
      path: '/select-user-enrollment'
      fullPath: '/select-user-enrollment'
      preLoaderRoute: typeof GloplaUserLayoutSelectUserEnrollmentIndexRouteImport
      parentRoute: typeof GloplaUserLayoutImport
    }
    '/_gloplaUserLayout/terms-of-service/': {
      id: '/_gloplaUserLayout/terms-of-service/'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof GloplaUserLayoutTermsOfServiceIndexRouteImport
      parentRoute: typeof GloplaUserLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug'
      path: '/user-attendances/$userAttendanceSlug'
      fullPath: '/user-attendances/$userAttendanceSlug'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugImport
      parentRoute: typeof EmbaUserLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout'
      path: '/user-attendances/$userAttendanceSlug'
      fullPath: '/user-attendances/$userAttendanceSlug'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugRoute
    }
    '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/': {
      id: '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/'
      path: '/enrollment-course/$enrollmentCourseId'
      fullPath: '/enrollment-course/$enrollmentCourseId'
      preLoaderRoute: typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutLearnerLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/'
      path: '/skill-check-test'
      fullPath: '/user-attendances/$userAttendanceSlug/skill-check-test'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/': {
      id: '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/'
      path: '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug'
      fullPath: '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug'
      preLoaderRoute: typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteImport
      parentRoute: typeof EmbaUserLayoutLearnerLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/'
      path: '/skill-check-test/result'
      fullPath: '/user-attendances/$userAttendanceSlug/skill-check-test/result'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/'
      path: '/lessons/$lessonSlug'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/'
      path: '/lessons/$lessonSlug/goal-dialog-result'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-result'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/'
      path: '/lessons/$lessonSlug/reflection-result'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-result'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/'
      path: '/lessons/$lessonSlug/role-play-result'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-result'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/': {
      id: '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/'
      path: '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content'
      fullPath: '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content'
      preLoaderRoute: typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutLearnerLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/'
      path: '/lessons/$lessonSlug/complete'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/complete'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/'
      path: '/lessons/$lessonSlug/goal-dialog-description'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-description'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/'
      path: '/lessons/$lessonSlug/reflection-description'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-description'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/'
      path: '/lessons/$lessonSlug/reflection-self-summarizing-answers'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-self-summarizing-answers'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/'
      path: '/lessons/$lessonSlug/role-play-description'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-description'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/'
      path: '/lessons/$lessonSlug/goal-dialog-session/$sessionSlug'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-session/$sessionSlug'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/'
      path: '/lessons/$lessonSlug/reflection-session/$sessionSlug'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-session/$sessionSlug'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
    '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/': {
      id: '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/'
      path: '/lessons/$lessonSlug/role-play-session/$sessionSlug'
      fullPath: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-session/$sessionSlug'
      preLoaderRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyImport
      parentRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutImport
    }
  }
}

// Create and export the route tree

interface EmbaUserLayoutLearnerLayoutRouteChildren {
  EmbaUserLayoutLearnerLayoutIndexRouteRoute: typeof EmbaUserLayoutLearnerLayoutIndexRouteRoute
  EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyRoute: typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyRoute
  EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteRoute: typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteRoute
  EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyRoute: typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyRoute
}

const EmbaUserLayoutLearnerLayoutRouteChildren: EmbaUserLayoutLearnerLayoutRouteChildren =
  {
    EmbaUserLayoutLearnerLayoutIndexRouteRoute:
      EmbaUserLayoutLearnerLayoutIndexRouteRoute,
    EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyRoute:
      EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyRoute,
    EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteRoute:
      EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteRoute,
    EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyRoute:
      EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyRoute,
  }

const EmbaUserLayoutLearnerLayoutRouteWithChildren =
  EmbaUserLayoutLearnerLayoutRoute._addFileChildren(
    EmbaUserLayoutLearnerLayoutRouteChildren,
  )

interface EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteChildren {
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyRoute
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyRoute
}

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteChildren: EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteChildren =
  {
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyRoute,
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyRoute,
  }

const EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteWithChildren =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute._addFileChildren(
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteChildren,
  )

interface EmbaUserLayoutUserAttendancesUserAttendanceSlugRouteChildren {
  EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteWithChildren
}

const EmbaUserLayoutUserAttendancesUserAttendanceSlugRouteChildren: EmbaUserLayoutUserAttendancesUserAttendanceSlugRouteChildren =
  {
    EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRoute:
      EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteWithChildren,
  }

const EmbaUserLayoutUserAttendancesUserAttendanceSlugRouteWithChildren =
  EmbaUserLayoutUserAttendancesUserAttendanceSlugRoute._addFileChildren(
    EmbaUserLayoutUserAttendancesUserAttendanceSlugRouteChildren,
  )

interface EmbaUserLayoutRouteChildren {
  EmbaUserLayoutLearnerLayoutRoute: typeof EmbaUserLayoutLearnerLayoutRouteWithChildren
  EmbaUserLayoutUserAttendancesUserAttendanceSlugRoute: typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugRouteWithChildren
}

const EmbaUserLayoutRouteChildren: EmbaUserLayoutRouteChildren = {
  EmbaUserLayoutLearnerLayoutRoute:
    EmbaUserLayoutLearnerLayoutRouteWithChildren,
  EmbaUserLayoutUserAttendancesUserAttendanceSlugRoute:
    EmbaUserLayoutUserAttendancesUserAttendanceSlugRouteWithChildren,
}

const EmbaUserLayoutRouteWithChildren = EmbaUserLayoutRoute._addFileChildren(
  EmbaUserLayoutRouteChildren,
)

interface GloplaUserLayoutRouteChildren {
  GloplaUserLayoutSelectUserEnrollmentIndexRouteRoute: typeof GloplaUserLayoutSelectUserEnrollmentIndexRouteRoute
  GloplaUserLayoutTermsOfServiceIndexRouteRoute: typeof GloplaUserLayoutTermsOfServiceIndexRouteRoute
}

const GloplaUserLayoutRouteChildren: GloplaUserLayoutRouteChildren = {
  GloplaUserLayoutSelectUserEnrollmentIndexRouteRoute:
    GloplaUserLayoutSelectUserEnrollmentIndexRouteRoute,
  GloplaUserLayoutTermsOfServiceIndexRouteRoute:
    GloplaUserLayoutTermsOfServiceIndexRouteRoute,
}

const GloplaUserLayoutRouteWithChildren =
  GloplaUserLayoutRoute._addFileChildren(GloplaUserLayoutRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof EmbaUserLayoutLearnerLayoutRouteWithChildren
  '/error-test': typeof ErrorTestIndexRouteRoute
  '/signin': typeof SigninIndexRouteRoute
  '/': typeof EmbaUserLayoutLearnerLayoutIndexRouteRoute
  '/select-user-enrollment': typeof GloplaUserLayoutSelectUserEnrollmentIndexRouteRoute
  '/terms-of-service': typeof GloplaUserLayoutTermsOfServiceIndexRouteRoute
  '/user-attendances/$userAttendanceSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteWithChildren
  '/enrollment-course/$enrollmentCourseId': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/skill-check-test': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteRoute
  '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteRoute
  '/user-attendances/$userAttendanceSlug/skill-check-test/result': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-result': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-result': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-result': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteRoute
  '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/complete': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-description': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-description': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-self-summarizing-answers': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-description': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-session/$sessionSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-session/$sessionSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-session/$sessionSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyRoute
}

export interface FileRoutesByTo {
  '': typeof GloplaUserLayoutRouteWithChildren
  '/error-test': typeof ErrorTestIndexRouteRoute
  '/signin': typeof SigninIndexRouteRoute
  '/': typeof EmbaUserLayoutLearnerLayoutIndexRouteRoute
  '/select-user-enrollment': typeof GloplaUserLayoutSelectUserEnrollmentIndexRouteRoute
  '/terms-of-service': typeof GloplaUserLayoutTermsOfServiceIndexRouteRoute
  '/user-attendances/$userAttendanceSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteWithChildren
  '/enrollment-course/$enrollmentCourseId': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/skill-check-test': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteRoute
  '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteRoute
  '/user-attendances/$userAttendanceSlug/skill-check-test/result': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-result': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-result': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-result': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteRoute
  '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/complete': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-description': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-description': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-self-summarizing-answers': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-description': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-session/$sessionSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-session/$sessionSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyRoute
  '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-session/$sessionSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_embaUserLayout': typeof EmbaUserLayoutRouteWithChildren
  '/_gloplaUserLayout': typeof GloplaUserLayoutRouteWithChildren
  '/_embaUserLayout/_learnerLayout': typeof EmbaUserLayoutLearnerLayoutRouteWithChildren
  '/error-test/': typeof ErrorTestIndexRouteRoute
  '/signin/': typeof SigninIndexRouteRoute
  '/_embaUserLayout/_learnerLayout/': typeof EmbaUserLayoutLearnerLayoutIndexRouteRoute
  '/_gloplaUserLayout/select-user-enrollment/': typeof GloplaUserLayoutSelectUserEnrollmentIndexRouteRoute
  '/_gloplaUserLayout/terms-of-service/': typeof GloplaUserLayoutTermsOfServiceIndexRouteRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugRouteWithChildren
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutRouteWithChildren
  '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestIndexRouteRoute
  '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugIndexRouteRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutSkillCheckTestResultIndexRouteRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogResultIndexRouteRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionResultIndexRouteRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayResultIndexRouteRoute
  '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/': typeof EmbaUserLayoutLearnerLayoutEnrollmentCourseEnrollmentCourseIdAttendanceAttendanceSlugRedirectRecommendedContentIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugCompleteIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogDescriptionIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionDescriptionIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSelfSummarizingAnswersIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlayDescriptionIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugGoalDialogSessionSessionSlugIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugReflectionSessionSessionSlugIndexRouteLazyRoute
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/': typeof EmbaUserLayoutUserAttendancesUserAttendanceSlugLessonSideBarLayoutLessonsLessonSlugRolePlaySessionSessionSlugIndexRouteLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/error-test'
    | '/signin'
    | '/'
    | '/select-user-enrollment'
    | '/terms-of-service'
    | '/user-attendances/$userAttendanceSlug'
    | '/enrollment-course/$enrollmentCourseId'
    | '/user-attendances/$userAttendanceSlug/skill-check-test'
    | '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug'
    | '/user-attendances/$userAttendanceSlug/skill-check-test/result'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-result'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-result'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-result'
    | '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/complete'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-description'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-description'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-self-summarizing-answers'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-description'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-session/$sessionSlug'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-session/$sessionSlug'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-session/$sessionSlug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/error-test'
    | '/signin'
    | '/'
    | '/select-user-enrollment'
    | '/terms-of-service'
    | '/user-attendances/$userAttendanceSlug'
    | '/enrollment-course/$enrollmentCourseId'
    | '/user-attendances/$userAttendanceSlug/skill-check-test'
    | '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug'
    | '/user-attendances/$userAttendanceSlug/skill-check-test/result'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-result'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-result'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-result'
    | '/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/complete'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-description'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-description'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-self-summarizing-answers'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-description'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/goal-dialog-session/$sessionSlug'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-session/$sessionSlug'
    | '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/role-play-session/$sessionSlug'
  id:
    | '__root__'
    | '/_embaUserLayout'
    | '/_gloplaUserLayout'
    | '/_embaUserLayout/_learnerLayout'
    | '/error-test/'
    | '/signin/'
    | '/_embaUserLayout/_learnerLayout/'
    | '/_gloplaUserLayout/select-user-enrollment/'
    | '/_gloplaUserLayout/terms-of-service/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout'
    | '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/'
    | '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/'
    | '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/'
    | '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  EmbaUserLayoutRoute: typeof EmbaUserLayoutRouteWithChildren
  GloplaUserLayoutRoute: typeof GloplaUserLayoutRouteWithChildren
  ErrorTestIndexRouteRoute: typeof ErrorTestIndexRouteRoute
  SigninIndexRouteRoute: typeof SigninIndexRouteRoute
}

const rootRouteChildren: RootRouteChildren = {
  EmbaUserLayoutRoute: EmbaUserLayoutRouteWithChildren,
  GloplaUserLayoutRoute: GloplaUserLayoutRouteWithChildren,
  ErrorTestIndexRouteRoute: ErrorTestIndexRouteRoute,
  SigninIndexRouteRoute: SigninIndexRouteRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_embaUserLayout",
        "/_gloplaUserLayout",
        "/error-test/",
        "/signin/"
      ]
    },
    "/_embaUserLayout": {
      "filePath": "_embaUserLayout.tsx",
      "children": [
        "/_embaUserLayout/_learnerLayout",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug"
      ]
    },
    "/_gloplaUserLayout": {
      "filePath": "_gloplaUserLayout.tsx",
      "children": [
        "/_gloplaUserLayout/select-user-enrollment/",
        "/_gloplaUserLayout/terms-of-service/"
      ]
    },
    "/_embaUserLayout/_learnerLayout": {
      "filePath": "_embaUserLayout/_learnerLayout.tsx",
      "parent": "/_embaUserLayout",
      "children": [
        "/_embaUserLayout/_learnerLayout/",
        "/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/",
        "/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/",
        "/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/"
      ]
    },
    "/error-test/": {
      "filePath": "error-test/index.route.tsx"
    },
    "/signin/": {
      "filePath": "signin/index.route.tsx"
    },
    "/_embaUserLayout/_learnerLayout/": {
      "filePath": "_embaUserLayout/_learnerLayout/index.route.tsx",
      "parent": "/_embaUserLayout/_learnerLayout"
    },
    "/_gloplaUserLayout/select-user-enrollment/": {
      "filePath": "_gloplaUserLayout/select-user-enrollment/index.route.tsx",
      "parent": "/_gloplaUserLayout"
    },
    "/_gloplaUserLayout/terms-of-service/": {
      "filePath": "_gloplaUserLayout/terms-of-service/index.route.tsx",
      "parent": "/_gloplaUserLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug",
      "parent": "/_embaUserLayout",
      "children": [
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
      ]
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug",
      "children": [
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/",
        "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/"
      ]
    },
    "/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/": {
      "filePath": "_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/_learnerLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/index.route.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/": {
      "filePath": "_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/index.route.tsx",
      "parent": "/_embaUserLayout/_learnerLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/index.route.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/index.route.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-result/index.route.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/index.route.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/": {
      "filePath": "_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/_learnerLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/complete/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-description/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-description/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-self-summarizing-answers/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-description/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-session/$sessionSlug/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/reflection-session/$sessionSlug/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    },
    "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/": {
      "filePath": "_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-session/$sessionSlug/index.route.lazy.tsx",
      "parent": "/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout"
    }
  }
}
ROUTE_MANIFEST_END */
